import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledOverlayStyled = styled.div<{$isOpen: boolean}>`
    ${({$isOpen}) => css`
        display: ${$isOpen ? 'block' : 'none'};
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        transition: opacity 0.3s ease-in-out;
        z-index: 1000;
    `}
`

export const StyledSheetContainer = styled.div<{$isOpen: boolean}>`
    ${({$isOpen, theme}) => css`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: ${theme.palette.neutral.white};
        border-radius: 10px 10px 0 0;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
        transform: ${$isOpen ? 'translateY(0)' : 'translateY(100%)'};
        transition: transform 0.3s ease-in-out;
        z-index: 1001;
        height: calc(100% - 40px);
        display: flex;
        flex-direction: column;
    `}
`

export const StyledModalCloseSection = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 5}px ${theme.spacing * 6}px;
    `}
`

export const StyledModalTitle = styled.div`
    ${({theme}) => css`
        ${theme.typography.textXl};
        color: ${theme.palette.neutral['900']};
        font-weight: 500;
        padding: 0 ${theme.spacing * 6}px;
    `}
`

export const StyledModalBody = styled(Flexbox)`
    ${({theme}) => css`
        flex: 1;
        overflow-y: auto;
        padding: ${theme.spacing * 4}px ${theme.spacing * 6}px;
        max-height: calc(100vh - 130px);
    `}
`
